import { storyblokEditable } from "gatsby-source-storyblok"
import React from "react"

import ImageItem from "../../../elements/V2/ImageItem"

const StoryblokImageItem = ({
  blok,
}: Storyblok.BlokProps<Storyblok.ImageItem>) => {
  return (
    <ImageItem
      imageUrl={blok.image.filename}
      imageAlt={blok.image.alt}
      alignment={blok.alignment}
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    />
  )
}

export default StoryblokImageItem
